import { formatDateOnly } from '../../../../../utils/dateUtils';
import { getCurrencySymbol } from '../../../../../utils/currencySymbol';

/**
 * Column configuration for Warranty Claims History Dialog
 * This defines the columns that will be displayed in the history table
 */
export const getWarrantyClaimsHistoryColumns = (th) => [
    {
        field: 'id',
        header: th('warrantyClaims.history.id'),
        sortable: true
    },
    {
        field: 'warrClaimsNo',
        header: th('warrantyClaims.history.warrClaimsNo'),
        sortable: true
    },
    {
        field: 'preAppNo',
        header: th('warrantyClaims.history.preAppNo'),
        sortable: true
    },
    {
        field: 'warrType',
        header: th('warrantyClaims.history.warrType'),
        sortable: true
    },
    {
        field: 'chassisNo',
        header: th('warrantyClaims.history.chassisNo'),
        sortable: true
    },
    {
        field: 'engineNumber',
        header: th('warrantyClaims.history.engineNumber'),
        sortable: true
    },
    {
        field: 'carDescription',
        header: th('warrantyClaims.history.carDescription'),
        sortable: true
    },
    {
        field: 'totalPrice',
        header: th('warrantyClaims.history.totalPrice'),
        body: (rowData) => {
            const value = rowData?.totalPrice ? rowData.totalPrice : '';
            const currencySymbol = rowData?.currency ? getCurrencySymbol(rowData.currency) : getCurrencySymbol('TRY');
            return `${value} ${currencySymbol}`;
        },
        sortable: true
    },
    {
        field: 'laborPrice',
        header: th('warrantyClaims.history.laborPrice'),
        body: (rowData) => {
            const value = rowData?.laborPrice ? rowData.laborPrice : '';
            const currencySymbol = rowData?.currency ? getCurrencySymbol(rowData.currency) : getCurrencySymbol('TRY');
            return `${value} ${currencySymbol}`;
        },
        sortable: true
    },
    {
        field: 'otherPayment',
        header: th('warrantyClaims.history.otherPayment'),
        body: (rowData) => {
            const value = rowData?.otherPayment ? rowData.otherPayment : '';
            const currencySymbol = rowData?.currency ? getCurrencySymbol(rowData.currency) : getCurrencySymbol('TRY');
            return `${value} ${currencySymbol}`;
        },
        sortable: true
    },
    {
        field: 'failureDate',
        header: th('warrantyClaims.history.failureDate'),
        body: (rowData) => formatDateOnly(rowData?.failureDate),
        sortable: true
    },
    {
        field: 'repairKm',
        header: th('warrantyClaims.history.repairKm'),
        sortable: true
    },
    {
        field: 'causeOfailure',
        header: th('warrantyClaims.history.causeOfailure'),
        sortable: true
    },
    {
        field: 'bulletNo',
        header: th('warrantyClaims.history.bulletNo'),
        sortable: true
    },
    {
        field: 'createdName',
        header: th('warrantyClaims.history.createdName'),
        sortable: true
    },
    {
        field: 'createdDate',
        header: th('warrantyClaims.history.createdDate'),
        body: (rowData) => formatDateOnly(rowData?.createdDate),
        sortable: true
    }
];
